import { isNull } from "../../util/TypeUtil";
import Content from "./Content";
import ContentFactory from "./ContentFactory";
import ENGLanguagePackContentType from "./ENGLanguagePackContentType";

/**
* File.js
* 
* Created on 4-nov-2013, 17:27:01
*
* @author Ivo Swartjes for Ranj
**/
export default class File extends Content {
    constructor(languagePack, contentID, fileID, name, icon, fileType, content, label) {
        super(File.NAME, File.TYPE, label, languagePack, contentID);
        this._fileID = fileID;
        this._name = name;
        this._icon = icon;
        this._fileType = fileType;
        this._content = content;
    }

    remove() {
        this.removeLanguagePackText(File.NAME_LABEL);
        this.removeLanguagePackContent(File.ICON_LABEL, ENGLanguagePackContentType.IMAGE);
        if (!isNull(this._content)) {
            this._content.remove();
            this._content = null;
        }
        super.remove();
    }

    getFileID() {
        return this.getLanguagePackText(File.FILE_ID_LABEL);
    }

    setFileID(value) {
        this.setLanguagePackText(File.FILE_ID_LABEL, value);
    }

    getName() {
        return this.getLanguagePackText(File.NAME_LABEL);
    }

    setName(value) {
        this.setLanguagePackText(File.NAME_LABEL, value);
    }

    getFileType() {
        return this.getLanguagePackText(File.FILE_TYPE_LABEL);
    }

    setFileType(value) {
        this.setLanguagePackText(File.FILE_TYPE_LABEL, value);
    }

    getPath() {
        return this.getLanguagePackText(File.PATH_LABEL) || "";
    }

    setPath(value) {
        this.setLanguagePackText(File.PATH_LABEL, value);
    }

    getIcon() {
        return this.getLanguagePackContent(File.ICON_LABEL, ENGLanguagePackContentType.IMAGE);
    }

    setIcon(value) {
        this.setLanguagePackContent(File.ICON_LABEL, ENGLanguagePackContentType.IMAGE, value);
    }

    getContent() {
        return this._content;
    }

    setContent(value) {
        this._content = value;
    }

    setPropertiesFromObject(object) {
        if (!isNull(object.content)) {
            this.setContent(ContentFactory.getContentFromObject(object.content, this._languagePack));
            delete object.content;
        }

        super.setPropertiesFromObject(object);
    }

    convertToObject() {
        const object = this.getObject([]);
        if (!isNull(this._content)) {
            object.content = this._content.convertToObject();
        }
        return object;
    }
}

File.NAME = "File";
File.TYPE = "engFile";

File.NAME_LABEL = "name";
File.ICON_LABEL = "icon";
File.PATH_LABEL = "path";

File.FILE_ID_LABEL = "fileID";
File.FILE_TYPE_LABEL = "type";

